export default "__VITE_ASSET__077659ed__"